// extracted by mini-css-extract-plugin
module.exports = {"header":"MicroCard_header__s9pAK","wrapper":"MicroCard_wrapper__9EGPS","container":"MicroCard_container__BxlWG","micro":"MicroCard_micro__rJ431"};